import React from 'react';
import TopAdm from './TopAdm';

const TopAdmContainer = () => <TopAdm />;

export default TopAdmContainer;
